import React from 'react'

import { 
    ErrorText 
} from '../../Styles/BaseStyles'

import { 
    ContactDiv, 
    ContactContentsDiv,
    ContactFormDiv, 
    ContactSectionHeader,
    FirstNameInputField, 
    LastNameInputField, 
    EmailInputField, 
    SubjectDiv,
    BodyTextArea, 
    SendButtonDiv, 
    SendButton,
} from '../../Styles/Components/ContactStyles'

import { 
    useForm,
    Controller 
} from 'react-hook-form'

import {
    AIRTABLE_API_KEY,
    AIRTABLE_BASE_ID
} from '../../Constants/AirTableEnums'

import Select from 'react-dropdown-select'

function Contact(props){
    const { register, errors, handleSubmit, reset, control, setError } = useForm({
        defaultValues: {
            firstname: '',
            lastname: '',
            email: '',
            subject:[],
            body: ''
        }
    })

    const subjects = [
        {value: 'Feature Request', label: 'Feature Request'}, 
        {value: 'Bug/Issue', label: 'Bug/Issue'},
        {value: 'Subscription', label: 'Subscription'},
        {value: 'General Question', label: 'General Question'}, 
        {value: 'Feedback', label:  'Feedback'}
    ]

    function sendMessage(data,e){
        if(data['subject'].length === 0){
            setError("subject", {
                type: "required"
            })
        }
        else{
            var Airtable = require('airtable');
            var base = new Airtable({apiKey: AIRTABLE_API_KEY}).base(AIRTABLE_BASE_ID);

            base('Contact Us Messages').create([
                {
                    "fields": {
                        'First Name': data.firstname,
                        'Last Name': data.lastname,
                        'Email': data.email,
                        'Subject': data.subject[0].value,
                        'Message': data.body
                    }
                }
            ], function(err, records) {
                    if (err) {
                        console.error(err);
                        return;
                    }
                    records.forEach(function (record) {
                        reset()
                    })
                }
            )
        }
    }
    
    return (
        <ContactDiv id="contact-section">
            <ContactContentsDiv>
                <ContactFormDiv id="contact-form">
                    <ContactSectionHeader>Contact Us</ContactSectionHeader>
                    <form>
                        <FirstNameInputField 
                            type="text" name="firstname" placeholder="First Name" 
                            ref={
                                register({ 
                                    required: true
                                })
                            }
                        />
                        <LastNameInputField 
                            type="text" name="lastname" placeholder="Last Name" 
                            ref={
                                register({ 
                                    required: true
                                })
                            }
                        />
                        <EmailInputField 
                            type="text" name="email" placeholder="Email" 
                            ref={
                                register({ 
                                    required: true,
                                    pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                })
                            }
                        />
                        <SubjectDiv>
                            <Controller 
                                as={
                                    <Select
                                        options={subjects}
                                        onChange={(values) => this.onChange(values)}
                                        placeholder="Select Subject"
                                        required
                                        searchable
                                        clearable={true}
                                        separator={true}
                                        style={
                                            {
                                                'fontSize': '1.6rem',
                                                'color': 'black',
                                                'backgroundColor': 'white',
                                                'margin': 0,
                                                'padding': '0rem 0.2rem'
                                            }
                                        }
                                    />
                                }
                                errors={errors}
                                control={control}
                                name="subject"
                            />
                        </SubjectDiv>
                        <BodyTextArea 
                            type="text" name="body" placeholder="Type message here..." 
                            ref={
                                register({ 
                                    required: true,
                                })
                            }
                        /><br/>
                        {(errors.firstname?.type === "required" || errors.lastname?.type === "required" || errors.email?.type === "required" || errors.subject?.type === "required" || errors.body?.type === "required") && <ErrorText p={0} ml={0} mr={0} mt="0.25rem" mb="0.25rem">*fields are incomplete</ErrorText>}
                        {(!((errors.firstname?.type === "required" || errors.lastname?.type === "required" || errors.email?.type === "required" || errors.subject?.type === "required" || errors.body?.type === "required")) && errors.email?.type === "pattern") && <ErrorText p={0} ml={0} mr={0} mt="0.25rem" mb="0.25rem">*invalid email</ErrorText>}
                        <SendButtonDiv>
                            <SendButton onClick={handleSubmit(sendMessage)}>Send Message</SendButton>
                        </SendButtonDiv>
                    </form>
                </ContactFormDiv>
            </ContactContentsDiv>
        </ContactDiv>
    )
}

export default Contact